export default {

    async addMember(state, payload) {
        state.members.push(payload);
    },


    async addNoteToMember(state, payload) {
        console.log(payload)
        const note = {
            id: payload.id,
            note: payload.note
        }
        const member = state.members.find(m => m.id === payload.memberId);
        console.log('member in addToNote', member)
        member.notes.push(note);
    },

    removeNoteFromMember(state, payload) {
        console.log('payload in removeNote', payload)
        const member = state.members.find(m => m.id === payload.id)
        member.notes = member.notes.filter(note => note.id != payload.noteId);
        const arrayToMap = []
        arrayToMap.push(member);
        state.members.map(member => arrayToMap.find(m => m.id === member.id) || member);
    },


    removeMember(state, payload) {
        console.log('payload for removeMember', payload)
        state.members = state.members.filter(member => member.id != payload.id)
    },

    changeLastContactDate(state, payload) {
        const member = state.members.find(m => m.id === payload.id);
        member.dateLastContact = payload.date
    },

    // addNoteToMember(state, payload) {
    //     console.log('payload in mutattion', payload);
    //     console.log('state.members', state.members);
    //     const member = state.members.find(m => m.id === payload.id);
    //     if (member.notes === undefined) {
    //         member.notes = new Array()
    //     }
    //     member.notes.push(payload.note);
    // },

    addGroupToMember(state, payload) {
        console.log('payload in mutation', payload)
        const member = state.members.find(m => m.id === payload.memberId);
        console.log('member', member)
        const group = {
            groupId: payload.group.id,
            groupName: payload.group.groupName
        }

        member.connectionGroup = group

        console.log('member.connectiongoup', member.connectionGroup)
        state.members.filter(m => m.id != member.id)
        state.members.push(member);
    },

    removeGroup(state, payload) {
        console.log('payload should be id', payload)
        const member = state.members.find(m => m.id === payload);
        member.connectionGroup = null
    },

    setMembers(state, payload) {

        state.members = payload;
    }


}

